import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import KibDivider from '@chewy/kib-divider-react'
import { KibContainer } from '@chewy/kib-layout-react'
import { NumberUtils } from '@pbt/pbt-ui-components'

import { PaymentMethod } from '~/constants/addPaymentDialogV2Constants'

import { useRefundDialog } from '../context/RefundDialogProvider'

import '@chewy/kib-layout-styles/dist/styles/kib-container.css'
import styles from './RefundSuccessScreen.module.scss'

export const RefundSuccessScreen = () => {
  const { t } = useTranslation(['Dialogs', 'Common'])
  const { dialogState } = useRefundDialog()
  const { refundAmount, selectedPayment } = dialogState

  const refundMethodToTranslationMap = useMemo(
    () => ({
      [PaymentMethod.CASH]: t('Common:PAYMENTS.CASH'),
      [PaymentMethod.CHECK]: t('Common:PAYMENTS.CHECK'),
      [PaymentMethod.CARECREDIT]: t('Dialogs:ADD_PAYMENT_DIALOG_V2.CARECREDIT'),
      [PaymentMethod.CREDIT_DEBIT]: t(
        'Dialogs:ADD_PAYMENT_DIALOG_V2.CREDIT_CARD',
      ),
    }),
    [t],
  )

  const getRefundMethodDisplay = (): string => {
    if (!selectedPayment) {
      return ''
    }

    const selectedPaymentMethod = selectedPayment.method?.name || ''

    if (dialogState.unlinked) {
      if (dialogState.refundMethod === PaymentMethod.CREDIT_DEBIT) {
        return t('Dialogs:ADD_PAYMENT_DIALOG_V2.CREDIT_DEBIT_SUCCESS', {
          method: selectedPaymentMethod,
          creditCardType: dialogState.refundCardType,
          creditLastFour: dialogState.refundLastFour,
        })
      }
      return refundMethodToTranslationMap[dialogState.refundMethod]
    }

    const isCreditCard = selectedPayment.cardType && selectedPayment.lastFour

    if (isCreditCard) {
      return t('Dialogs:ADD_PAYMENT_DIALOG_V2.CREDIT_DEBIT_SUCCESS', {
        method: selectedPaymentMethod,
        creditCardType: selectedPayment.cardType?.name,
        creditLastFour: selectedPayment.lastFour,
      })
    }

    return selectedPaymentMethod
  }

  return (
    <KibContainer className={styles.refundSuccessContainer}>
      <div className={styles.refundSuccessTitle}>
        {t('Common:PAYMENTS.REFUND_DETAILS')}
      </div>
      <div className={styles.refundSuccessInfoRow}>
        <div className={styles.refundSuccessInfoRowLabel}>
          {t('Common:PAYMENTS.AMOUNT_REFUNDED')}
        </div>
        <div className={styles.refundSuccessInfoRowValue}>
          {NumberUtils.formatMoney(refundAmount)}
        </div>
      </div>
      <KibDivider className={styles.refundSuccessDivider} color="alternate" />
      <div className={styles.refundSuccessInfoRow}>
        <div className={styles.refundSuccessInfoRowLabel}>
          {t('Common:PAYMENTS.PAYMENT_METHOD')}
        </div>
        <div className={styles.refundSuccessInfoRowValue}>
          {getRefundMethodDisplay()}
        </div>
      </div>
      <KibDivider className={styles.refundSuccessDivider} color="alternate" />
    </KibContainer>
  )
}
